//FROMCDN
// Questa classe `McUtils` raccoglie utility generiche riutilizzabili per la gestione di formattazione valuta, parsing HTML, logging avanzato e aggiornamento dinamico di elementi HTML.
// Non richiede data attributes o elementi HTML specifici: tutte le funzioni sono statiche e possono essere richiamate direttamente tramite `McUtils`.

class McUtils {

  static VERSION = '2.0.4';

  // Formatta un importo numerico in formato valuta secondo il formato definito in window.theme.moneyFormat
  // Esempio: 123456 -> "1 234,56 €" (a seconda del formato configurato)
  static money = (amount) => {
    const n = Number(amount);
    if(isNaN(n)) { console.error('McUtils.money: Il valore passato non è un numero valido:', amount); return ''; }

    // Divide per 100, fissa a 2 decimali, usa la virgola come separatore decimale e lo spazio per le migliaia
    const a = parseFloat(n/100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    if(window.theme?.moneyFormat === undefined) { console.warn('McUtils.money: La formattazione della valuta non è definita in window.theme.moneyFormat'); return a; }
    
    return window.theme.moneyFormat.replace('{{amount}}', a).replace('{{amount_with_comma_separator}}', a);
  }

  // Ottiene un oggetto Document a partire da una stringa HTML
  static getDocument = (html) => {
    if(typeof html !== 'string') { console.error('McUtils.getDocument: il primo parametro deve essere una stringa HTML'); return; }
    const parser = new DOMParser();
    return parser.parseFromString(html, 'text/html');
  }

  // Converte una stringa in uno slug "handle" (come la funzione handleize di Liquid)
  // Esempio: "Ciao Mondo!" -> "ciao-mondo"
  static handleize = (str) => {
    return str.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '');
  }

  // Log avanzato: mostra il chiamante e i parametri solo in ambiente di sviluppo o debug
  static log = (...args) => {
    if(Shopify.theme.role == 'development' || window.theme.debug) {
      try {
          const err = new Error();
          const stack = err.stack || '';
          const stackLines = stack.split('\n');
          const callerLine = stackLines[2] || '';
          let caller = 'unknown';
          // Estrae il nome della funzione chiamante dallo stack trace
          const matchFunction = callerLine.match(/at\s+([\w.$<>]+)\s*\(/);
          if (matchFunction && matchFunction[1]) {
              caller = matchFunction[1];
          } else {
              const matchFile = callerLine.match(/at\s+(.+:\d+:\d+)/);
              if (matchFile && matchFile[1]) {
                  caller = matchFile[1];
              }
          }
          // Log con chiamante + argomenti
          console.log('🌝', `[${caller}]`, ...args);
      } catch (e) {
          // Fallback in caso di errore estrazione del chiamante
          console.log('🌝', ...args);
      }
    }
  }

  // Aggiorna dinamicamente il contenuto di un elemento HTML con quello di un nuovo elemento estratto da una stringa HTML
  // html: stringa HTML sorgente
  // elementToReload: elemento da aggiornare
  // selectorOfNewElement: selettore CSS dell'elemento da cui prendere il nuovo contenuto
  static reloadElement = (html, elementToReload, selectorOfNewElement) => {
    if(!html || !elementToReload || !selectorOfNewElement) { console.error('reloadElement: parametri mancanti o non validi'); return; }
    if(typeof html !== 'string') { console.error('reloadElement: il primo parametro deve essere una stringa HTML'); return; }
    if(!(elementToReload instanceof HTMLElement)) { console.error('reloadElement: il secondo parametro deve essere un elemento HTML'); return; }
    if(typeof selectorOfNewElement !== 'string') { console.error('reloadElement: il terzo parametro deve essere una stringa CSS selector'); return; }

    const newDocument = McUtils.getDocument(html);
    const newElement = newDocument.querySelector(selectorOfNewElement);
    if(!newElement) { console.error('reloadElement: Elemento non trovato nella risposta:', selectorOfNewElement); return; }
    
    elementToReload.innerHTML = newElement.innerHTML;
  }

  static addCss = (url) => {
    if (!url || typeof url !== 'string') { console.error('McElement.addCss: Il parametro "url" deve essere una stringa valida.'); return; }
    const element = document.querySelector(`link[href="${url}"]`);
    if (element) { console.warn(`McElement.addCss: Il CSS "${url}" è già stato aggiunto.`, element); return; }
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    document.head.appendChild(link);
  }

}

// Esporta la classe McUtils come globale e come modulo
window.McUtils = McUtils;
export default McUtils;